import { InjectionToken } from '@angular/core';
import { SelectionManagerService } from './selection-manager.service';

export type SelectionContext =
  | 'globalSelection'
  | 'groupSelection'
  | 'pairSelection'
  | 'playlistSelection'
  | 'accountSelection'
  | 'accountLibrarySelection'
  | 'clientLibrarySelection'
  | 'archiveSelection'
  | 'gallerySelection'
  | 'photoSelection'
  | 'locationsSelection'
  | 'teamSelection'
  | 'customizationPhotosSelection';

export const GLOBAL_SELECTION = new InjectionToken<SelectionManagerService>('GLOBAL_SELECTION');
export const GROUP_SELECTION = new InjectionToken<SelectionManagerService>('GROUP_SELECTION');
export const PAIR_SELECTION = new InjectionToken<SelectionManagerService>('PAIR_SELECTION');
export const PLAYLIST_SELECTION = new InjectionToken<SelectionManagerService>('PLAYLIST_SELECTION');
export const ACCOUNT_SELECTION = new InjectionToken<SelectionManagerService>('ACCOUNT_SELECTION');
export const ACCOUNT_LIBRARY_SELECTION = new InjectionToken<SelectionManagerService>(
  'ACCOUNT_LIBRARY_SELECTION',
);
export const CLIENT_LIBRARY_SELECTION = new InjectionToken<SelectionManagerService>(
  'CLIENT_LIBRARY_SELECTION',
);
export const ARCHIVE_SELECTION = new InjectionToken<SelectionManagerService>('ARCHIVE_SELECTION');
export const GALLERY_SELECTION = new InjectionToken<SelectionManagerService>('GALLERY_SELECTION');
export const PHOTO_SELECTION = new InjectionToken<SelectionManagerService>('PHOTO_SELECTION');
export const LOCATIONS_SELECTION = new InjectionToken<SelectionManagerService>(
  'LOCATIONS_SELECTION',
);
export const TEAM_SELECTION = new InjectionToken<SelectionManagerService>('TEAM_SELECTION');
export const CUSTOMIZATION_PHOTOS_SELECTION = new InjectionToken<SelectionManagerService>(
  'CUSTOMIZATION_PHOTOS_SELECTION',
);

export const SELECTION_CONTEXT_TOKEN_MAP: Record<
  SelectionContext,
  InjectionToken<SelectionManagerService>
> = {
  globalSelection: GLOBAL_SELECTION,
  groupSelection: GROUP_SELECTION,
  pairSelection: PAIR_SELECTION,
  playlistSelection: PLAYLIST_SELECTION,
  accountSelection: ACCOUNT_SELECTION,
  accountLibrarySelection: ACCOUNT_LIBRARY_SELECTION,
  clientLibrarySelection: CLIENT_LIBRARY_SELECTION,
  archiveSelection: ARCHIVE_SELECTION,
  gallerySelection: GALLERY_SELECTION,
  photoSelection: PHOTO_SELECTION,
  locationsSelection: LOCATIONS_SELECTION,
  teamSelection: TEAM_SELECTION,
  customizationPhotosSelection: CUSTOMIZATION_PHOTOS_SELECTION,
};
